<script lang="ts">
	import type { Reports$result } from '$houdini'
	import type { SvelteAsr } from 'types/common'

	import { ReportList } from '@isoftdata/svelte-report-viewer'
	import { onMount } from 'svelte'
	import { saveFavoriteReports } from 'utility/report-viewer-helper'

	interface Props {
		asr: SvelteAsr
		selectedReportId: number | null
		selectedCategory: string | null
		reportList: Reports$result['reports']['items']
		favorites: Array<string>
	}

	let {
		//
		asr,
		selectedReportId = $bindable(),
		selectedCategory = $bindable(),
		reportList,
		favorites,
	}: Props = $props()

	$effect(() => {
		saveFavoriteReports(favorites)
	})

	function getFirstReportIdForCategory(category: string | null) {
		if (!category) {
			return null
		}

		const report = reportList.find(report => report.category === category)
		return report?.id ?? null
	}

	onMount(() => {
		if (selectedReportId && !selectedCategory) {
			const report = reportList.find(report => report.id === selectedReportId)
			if (report) {
				selectedCategory = report.category
				asr.go(null, { selectedReportId, selectedCategory })
			}
		}
	})
</script>

<ReportList
	{reportList}
	bind:selectedCategory
	bind:selectedReportId
	enableFavorites
	bind:favorites
	reportClick={ctx => {
		selectedCategory = ctx.category
		selectedReportId = ctx.reportId ?? getFirstReportIdForCategory(selectedCategory)
		asr.go('app.report-viewer.reports.preview', { selectedReportId, selectedCategory })
	}}
>
	<uiView></uiView>
</ReportList>
